import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useSessionStore } from '../../hooks/useSessionStore';
import axios from 'axios';
import { UsuarioContext } from '../../contexts/UsuarioContext';

const SuccessPage = () => {
    const [searchParams] = useSearchParams();
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

    const sessionId = searchParams.get("session_id");
    const nombrePlan = searchParams.get("name_plan");

    useEffect(() => {

        if (!sessionId) {
            navigate('/');
            return;
        }

        const handleSubscription = async () => {
            let data = {
                session_id : sessionId,
                plan_name: nombrePlan
            }
            try {
                await axios({
                    method: 'post',
                    url: window.ipdirection + 'suscripcion/confirmar-suscripcion/',
                    headers: {
                        Authorization: 'Bearer ' + Usuario.access,
                    },
                    data: data,
                })
            } catch (error) {
                console.error("Error al confirmar la suscripción:", error);
            } finally {
                setLoading(false);
            }
        };

        handleSubscription();
    }, [navigate, searchParams]);

    return (
        <div>
            <h1>¡Enhorabuena!</h1>
            {
                loading ? (
                    <p>Loading...</p>
                ):(
                    <>
                        <p>Gracias por suscribirte a: {nombrePlan}.</p>
                        <div className='button btn-success' onClick={() => navigate('/miPlan')}>
                            Volver
                        </div>
                    </>
                )
            }
        </div>
    );
};

export default SuccessPage;